import React from "react";

type Priority = "LOW" | "MEDIUM" | "HIGH";

export type PriorityBadgeProps = {
  priority: Priority;
  className?: string;
  style?: React.CSSProperties;
};

const getPriorityProps = (
  priority: Priority,
): { label: string; className: string } => {
  switch (priority) {
    case "HIGH":
      return { label: "High", className: "bg-danger text-light" };
    case "MEDIUM":
      return { label: "Medium", className: "bg-warning text-dark" };
    case "LOW":
    default:
      return { label: "Low", className: "bg-success text-light" };
  }
};

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({
  priority,
  className = "",
  style = {},
}) => {
  const { label, className: priorityClass } = getPriorityProps(priority);

  return (
    <span
      className={`badge ms-2 fw-semibold text-uppercase ${priorityClass} ${className}`}
      style={{
        fontSize: "0.85rem",
        letterSpacing: "0.03em",
        verticalAlign: "middle",
        boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
        ...style,
      }}
    >
      {label}
    </span>
  );
};

export default PriorityBadge;
